export enum VariableType {
    String = 'string',
    Integer = 'integer',
    Double = 'double',
    Unknown = 'unknown',
}
